import styled from "@emotion/styled";

// components
import BaseSubCategory from "shared/components/Header/DesktopHeader/components/Menu/components/SubCategory";

export const Container = styled.div`
    flex: 1;
    display: flex;
    margin-right: 34px;

    .sc-inner {
        height: 70vh;
        width: 100%;
        max-height: 520px;
        border-right: 1px solid #000;
    }
`;

export const SubCategory = styled(BaseSubCategory)<{ totalColumnCount: number }>`
    ${({ totalColumnCount }) => `width: calc(100% / ${totalColumnCount});`}
    padding-right: 20px;

    &:last-child {
        padding-right: 0;
    }
`;
